import { Component, computed, inject, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatTabsModule } from "@angular/material/tabs";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTableModule } from "@angular/material/table";
import { ServiceDetail, ParsedServiceDetail } from "@features/order-detail/models/order-services.model";
import { UtilService } from "@core/utils/util.service";
import {
  ServiceCancelData,
  ServiceRescheduleData,
} from "@features/service-actions/models/service-action.model";
import { DialogManagerService } from "app/shared/services/dialog-manager.service";
import { TenantUrlUtilService } from "app/shared/services/tenant-url-util.service";
import { ServiceCancelDialogComponent } from "@features/service-actions/components/service-cancel-dialog/service-cancel-dialog.component";
import { ServiceRescheduleDialogComponent } from "@features/service-actions/components/service-reschedule-dialog/service-reschedule-dialog.component";
import { ImagesCarouselComponent } from "@shared/components/ui/images-carousel/images-carousel.component";
import { ServicesOrderState } from "@features/services/services-order.state";
import { ServiceTimelineState } from "@features/services/services/service-timeline.state";
import { ServiceTimelineComponent } from "../service-timeline/service-timeline.component";
import { ServiceTimelineStep } from "../../models/service-timeline.model";
import { ServiceVisitsDrawerComponent } from "../service-visits-drawer/service-visits-drawer.component";
import { ServiceCancellationAlertComponent } from "../service-cancellation-alert/service-cancellation-alert.component";

@Component({
  selector: "app-service-detail-tab",
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    ServiceTimelineComponent,
    ServiceCancellationAlertComponent,
  ],
  templateUrl: "./service-detail-tab.component.html",
  styleUrl: "./service-detail-tab.component.scss",
  providers: [ServiceTimelineState]
})
export class ServiceDetailTabComponent {
  readonly state = inject(ServicesOrderState);
  readonly serviceData = computed(() => this.state.selectedService());
  readonly technicianName = computed(() => {
    const tecnico = this.serviceData()?.tecnico;
    return tecnico?.[0]?.nombre ?? null;
  });

  utilService = inject(UtilService);
  dialogManagerService = inject(DialogManagerService);
  displayedColumns = ["sku", "producto", "cantidad"];
  private readonly tenantUrlUtil = inject(TenantUrlUtilService);

  readonly serviceTimelineDates = signal<Map<string, Date | null>>(new Map());

  onTimelineDateChange(serviceId: string, date: Date | null): void {
    const map = new Map(this.serviceTimelineDates());
    map.set(serviceId, date);
    this.serviceTimelineDates.set(map);
  }

  getCancellationDate(service: ParsedServiceDetail): Date | null {
    const trackingDate = this.state.getServiceTrackingDate(service);
    if (trackingDate) return trackingDate;

    return this.serviceTimelineDates().get(service.id) ?? null;
  }

  onOpenImagesCarouselDialog(event: MouseEvent, images: object[]) {
    this.dialogManagerService.openCarousel(
      ImagesCarouselComponent,
      images,
      event,
    );
  }

  onOpenServiceCancelDrawer(event: MouseEvent, serviceDetail: ParsedServiceDetail) {
    const currentService = this.serviceData();
    const data: ServiceCancelData = {
      tenantId: this.tenantUrlUtil.normalizedTenant()!,
      orderId: this.tenantUrlUtil.getQueryParams().orderId || "",
      serviceId: currentService?.osId || "",
      serviceItemId: serviceDetail.id,
      serviceDetail: serviceDetail,
      seller: currentService?.seller || "",
      isAllowedToCancel: true,
    };
    this.dialogManagerService.openDrawer(
      ServiceCancelDialogComponent,
      data,
      event,
    );
  }

  onOpenServiceRescheduleDrawer(
    event: MouseEvent,
    serviceDetail: ParsedServiceDetail,
  ) {
    const currentService = this.serviceData();
    const data: ServiceRescheduleData = {
      tenantId: this.tenantUrlUtil.normalizedTenant()!,
      serviceId: currentService?.osId || "",
      serviceItemId: serviceDetail.id,
      seller: currentService?.seller || "",
      availableReschedule:
        currentService?.options.availableReschedule || false,
    };
    this.dialogManagerService.openDrawer(
      ServiceRescheduleDialogComponent,
      data,
      event,
    );
  }

  onOpenVisitsDrawer(event: MouseEvent, serviceDetail: ParsedServiceDetail): void {
    const data = this.serviceData();
    this.dialogManagerService.openDrawer(
      ServiceVisitsDrawerComponent,
      { 
        serviceDetailId: serviceDetail.serviceDetailId || serviceDetail.id,
        serviceOrderNumber: serviceDetail.detailId || serviceDetail.id
      },
      event,
      '271px'
    );
  }

  hasVisits(): boolean {
    return true;
  }

  onViewMoreTimelineDetail(step: ServiceTimelineStep): void {
    console.log('Timeline detail:', step);
  }
}
